import React from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment-jalaali';
import Texts from '../Texts';

const Footer: React.FC = () => {
  return (
    <>
      <Box
        textAlign="center"
        py={0}
        bgcolor="grey.200"
        mt={5}
        sx={{
          // 100vw counts the vertical scrollbar, so on pages tall enough to
          // scroll the footer became ~15px wider than the content area and
          // introduced a horizontal scrollbar. 100% is the usable width.
          width: '100%',
          height: 56,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        {/* متن کپی رایت در وسط */}
        <Typography
          variant="body2"
          style={{
            fontFamily: 'IRANYekanXFaNum',
            fontSize: '14px',
            color: '#666',
            position: 'absolute',
            left: '50%',
            direction: 'rtl',
            transform: 'translateX(-50%)',
          }}
        >
           {Texts.footer.buttonTxt} {'1391 -'} {moment().jYear()}
        </Typography>

      </Box>
    </>
  );
};

export default Footer;
